import { bindActionCreators } from '@reduxjs/toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { TextField } from '@eatclubapp/ec-component-library';
import { useTheme } from '@mui/material/styles';
import { connect } from 'react-redux';
import useStyles, { textFieldStyles } from './CleanTextFieldStyles';

const CleanTextField = ({
  label,
  value,
  onChange,
  autofocus,
  onFocus,
  onBlur,
  style,
  required,
  disabled,
  error,
  ...others
}) => {
  const theme = useTheme();
  const classes = useStyles({ style });
  return (
    <TextField
      className={classes.container}
      label={label}
      value={value}
      type='text'
      onChange={onChange}
      placeholder='Empty'
      autofocus={autofocus}
      onFocus={onFocus}
      onBlur={onBlur}
      required={required}
      disabled={disabled}
      error={error}
      {...others}
      style={textFieldStyles(theme, disabled)}
    />
  );
};

CleanTextField.defaultProps = {
  label: '',
  value: '',
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
  autofocus: false,
  style: {},
  required: false,
  disabled: false,
  error: null,
};

CleanTextField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  autofocus: PropTypes.bool,
  style: PropTypes.shape({
    container: PropTypes.shape({}),
    innerContainer: PropTypes.shape({}),
    label: PropTypes.shape({}),
    textFieldInner: PropTypes.shape({}),
    input: PropTypes.shape({}),
    inputActive: PropTypes.shape({}),
    inputHover: PropTypes.shape({}),
    placeholder: PropTypes.shape({}),
    textField: PropTypes.shape({}),
    errorText: PropTypes.shape({}),
    inputPrefix: PropTypes.shape({}),
    disabled: PropTypes.shape({}),
  }),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CleanTextField);
